import { graphql, useStaticQuery } from 'gatsby';
import { FC, useState } from 'react';

// Quarks
import Flex from 'quarks/Flex';
import type { FlexProps } from 'quarks/interpolations/flex';

import ComponentButton from 'components/Button/ComponentButton';
import Popup from 'components/CardDeck/Popup';
import TestimonialVideoCard from 'components/Cards/TestimonialVideoCard';

// Types
import type { ContentfulComponentCardDeck, ContentfulComponentCardDeckConnection } from 'graphqlTypes';

interface CardDeckProps extends FlexProps, ContentfulComponentCardDeck {
  backgroundIsDark: boolean;
  isNoMoreButton?: boolean;
}

interface TipstoolData {
  testimonialCards: ContentfulComponentCardDeckConnection;
}

const ComponentCardDeck: FC<CardDeckProps> = ({ card, backgroundIsDark, isNoMoreButton, ...props }) => {
  const { testimonialCards } = useStaticQuery<TipstoolData>(graphql`
    query getRecentTestimonialCardQuery {
      testimonialCards: allContentfulComponentCardDeck(filter: { resourceType: { eq: "Testimonial" } }) {
        nodes {
          card {
            ...contentfulComponentCard
          }
        }
      }
    }
  `);

  const allCards = testimonialCards?.nodes[0]?.card;
  const dataCard = card || allCards;

  const [current, setCurrent] = useState(0);
  const [active, setActive] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const handleActive = (idx: number) => {
    setCurrent(idx);
    setIsOpen(true);
  };
  const handleExpand = () => {
    setActive(!active);
    const position = document.querySelector('#testimonials-card-deck-section');
    if (position && active) {
      window.scrollTo({
        top: position.getBoundingClientRect().top + window.scrollY - 125,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Flex flexDirection="column" alignItems="center" gap="48px" overflowX="hidden" overflowY="hidden" {...props}>
      {dataCard && dataCard.length > 0 && (
        <Flex width="100%" maxWidth="100%" marginX="auto" flexWrap="wrap" justifyContent="center" gap="30px">
          {dataCard.slice(0, active ? dataCard.length : 3).map(
            (item, idx) =>
              item?.__typename === 'ContentfulComponentCard' && (
                <Flex
                  key={item?.id}
                  flexDirection="column"
                  gap="16px"
                  alignItems="center"
                  width="100%"
                  maxWidth="100%"
                  md={{ maxWidth: 'calc((100% - 30px) / 2)' }}
                  lg={{ maxWidth: 'calc((100% - 60px) / 3)' }}
                >
                  <TestimonialVideoCard backgroundIsDark={backgroundIsDark} {...item} />
                  <Flex onClick={() => handleActive(idx)}>
                    <ComponentButton label="View a Transcript" buttonColor="Gray 900 Link" isButton />
                  </Flex>
                </Flex>
              ),
          )}
        </Flex>
      )}
      {!isNoMoreButton && (
        <Flex justifyContent="center" alignItems="center" width="100%" onClick={() => handleExpand()}>
          <ComponentButton label={`View ${active ? 'Less' : 'More'} Testimonials`} buttonColor="Navy White" isButton />
        </Flex>
      )}
      {dataCard && isOpen && (
        <Popup
          desc={dataCard?.[current]?.__typename === 'ContentfulComponentCard' && dataCard?.[current]?.transcript}
          open={isOpen}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Flex>
  );
};

export default ComponentCardDeck;
